import * as yup from 'yup';

const validations = {
  email: yup
    .string()
    .email('Не корректный email')
    .required('Заполните обязательное поле'),
};

export default yup.object().shape(validations);
